<template>
  <RevLink
    class="body-2-link relative bottom-2 hidden pl-12 md:inline-flex"
    variant="link"
    @click="onLinkClick"
  >
    {{ i18n(translations.learnMore) }}
  </RevLink>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from '../../ReviewPhotosGuidance.translations'

const i18n = useI18n()

function onLinkClick() {
  openModal(MODAL_NAMES.CONDITION_COMPARISON)
}
</script>
